<template>
  <li class="list-item">
    <div class="list-item__first">
      <span>{{item.deptName}}</span>
      <span>{{item.groupName}}</span>
      <span>{{item.empName}}</span>
    </div>
    <div class="list-item__user">用户名称：<van-button type="primary" size="mini" @click="$emit('click-item')">{{item.companyName}}</van-button></div>
    <div>地区：{{item.address}}</div>
  </li>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    item: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  padding: 14px;
  background-color: #fff;
  box-shadow: rgba(42, 45, 51, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  margin-top: 16px;
  &__first span {
    margin-right: 5px;
  }
  &__user {
    display: flex;
    align-items: center;
  }
}
</style>
